export default __webpack_public_path__ + "static/media/Search.8f04f279.svg";